import { Stack, Typography } from '@mui/material';

export const TeamDescription = ({
  description,
}: {
  description?: string | null;
}) =>
  description ? (
    <Stack sx={{ gap: 1 }}>
      <Typography
        variant="caption"
        sx={{
          color: 'text.secondary',
        }}
      >
        Team Description
      </Typography>
      <Typography variant="body2" sx={{ pb: 5.5, whiteSpace: 'pre-line' }}>
        {description}
      </Typography>
    </Stack>
  ) : null;
